import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import JsonBlockGenerator from '../components/JsonBlockGenerator';

export default class VvnPetInfo extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <JsonBlockGenerator filename={'vvn_general_pet_info.json'} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
